(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const cards = Array.from(root.querySelectorAll('[data-product]'));
    if (!cards.length) return;
    const grid = root.querySelector('[data-grid]');
    const search = root.querySelector('[data-search]');
    const category = root.querySelector('[data-category]');
    const model = root.querySelector('[data-model]');
    const sort = root.querySelector('[data-sort]');
    const count = root.querySelector('[data-count]');
    const empty = root.querySelector('[data-empty]');
    const categories = [...new Set(cards.map(c => c.dataset.category))].sort();
    const models = [...new Set(cards.map(c => c.dataset.model))].sort();
    for (const value of categories) category.add(new Option(value, value));
    for (const value of models) model.add(new Option(value, value));
    function update() {
      const terms = search.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      let shown = 0;
      for (const card of cards) {
        const haystack = [card.dataset.title, card.dataset.category, card.dataset.model].join(' ').toLocaleLowerCase();
        card.hidden = Boolean((category.value && card.dataset.category !== category.value) || (model.value && card.dataset.model !== model.value) || !terms.every(term => haystack.includes(term)));
        if (!card.hidden) shown++;
      }
      count.textContent = shown + (shown === 1 ? ' item found' : ' items found');
      empty.hidden = shown !== 0;
      const sorted = [...cards];
      if (sort.value === 'az') sorted.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title));
      if (sort.value === 'za') sorted.sort((a,b) => b.dataset.title.localeCompare(a.dataset.title));
      if (sort.value === 'price-asc') sorted.sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price));
      if (sort.value === 'price-desc') sorted.sort((a,b) => Number(b.dataset.price) - Number(a.dataset.price));
      if (sort.value === 'featured') sorted.splice(0, sorted.length, ...cards);
      grid.replaceChildren(...sorted);
    }
    function clear() {search.value='';category.value='';model.value='';sort.value='featured';update()}
    search.addEventListener('input', update);
    category.addEventListener('change', update);
    model.addEventListener('change', update);
    sort.addEventListener('change', update);
    root.querySelectorAll('[data-clear]').forEach(button => button.addEventListener('click', clear));
    root.querySelectorAll('[data-category-tile]').forEach(button => button.addEventListener('click', () => {
      category.value = button.dataset.categoryTile;
      update();
      root.querySelector('.rshop__catalog').scrollIntoView({behavior:'smooth'});
    }));
    update();
  }
  document.querySelectorAll('[data-rshop]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rshop]').forEach(init));
})();
